const KEY_TOKEN = 'signedge:deviceToken';
const KEY_DEVICE = 'signedge:deviceMeta';

export function getDeviceToken() {
  return localStorage.getItem(KEY_TOKEN);
}

export function setDeviceToken(token) {
  localStorage.setItem(KEY_TOKEN, token);
}

export function clearDeviceToken() {
  localStorage.removeItem(KEY_TOKEN);
  localStorage.removeItem(KEY_DEVICE);
}

export function getDeviceMeta() {
  const raw = localStorage.getItem(KEY_DEVICE);
  if (!raw) return null;
  try {
    return JSON.parse(raw);
  } catch {
    return null;
  }
}

export function setDeviceMeta(meta) {
  localStorage.setItem(KEY_DEVICE, JSON.stringify(meta));
}

export function isPaired() {
  return !!getDeviceToken();
}
